/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as alertScenarioV1 from "./keyapis_dial_alert_scenario_v1.pb"

/**
 * Сервис реализует функционал получения информации для взаимодействия с ГО ЧС
 */

/**
 * Сервис получения информации для взаимодействия с ГО ЧС
 */
export class DialEmergencyServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения sip-логина устройства.
   * Метод доступен для: ApiKey
   */
  GetSipLogin = (req: GetSipLoginRequestDto, init?: RequestInit): Promise<GetSipLoginResponseDto> => {
    return fm.request<GetSipLoginRequestDto, GetSipLoginResponseDto>(`${this.host}/dial/internal/api/v1/sip_login${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос на получение списка устройств
 */
export type GetSipLoginRequestDto = {
  /**
   * Фильтр по АБС-номеру устройства.
   * # Паттерн: /^\+[1-9][0-9]{10}$/
   */
  abcNumber: string
}
/**
 * Ответ на запрос на получение списка устройств
 */
export type GetSipLoginResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * SIP-Логин устройства
   */
  readonly sipAccount: string
  /**
   * Ошибка
   */
  readonly error: GetSipLoginResponseErrorDto
}>
/**
 * Ошибка запроса на получение списка устройств
 */
export type GetSipLoginResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: alertScenarioV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса на получение списка устройств
 */
export type GetSipLoginResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: alertScenarioV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на получение списка устройств
   */
  "GetSipLoginRequest": {
    "kind": "class",
    "text": "Запрос на получение списка устройств",
    "fields": {
      /**
       * Фильтр по АБС-номеру устройства.
       * # Паттерн: /^\+[1-9][0-9]{10}$/
       */
      "abcNumber": {
        "type": "string",
        "text": "Фильтр по АБС-номеру устройства.\n# Паттерн: /^\+[1-9][0-9]{10}$/",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "pattern": {
            "value": /^\+[1-9][0-9]{10}$/,
            "message": "Значение не соответствует регулярному выражению. Паттерн: /^\+[1-9][0-9]{10}$/"
          }
        }
      },
    },
  },
  /**
   * Ответ на запрос на получение списка устройств
   */
  "GetSipLoginResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение списка устройств",
    "fields": {
      /**
       * SIP-Логин устройства
       */
      "sipAccount": {
        "type": "string",
        "text": "SIP-Логин устройства",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetSipLoginResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на получение списка устройств
   */
  "GetSipLoginResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на получение списка устройств",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
}